import { Directive, ElementRef, HostBinding, Input } from '@angular/core';

@Directive({ selector: 'button' })
export class ButtonDirective
{
    @Input() color: string = 'primary';
    @Input() fill: 'clear' | 'none' | 'outline' | 'outline-mono' | 'solid' = 'solid';

    constructor(private el: ElementRef) {}

    @HostBinding('class')
    get klass()
    {
        switch (this.fill)
        {
            case 'clear': return 'es-button clear';
            case 'outline': return 'es-button outline';
            case 'outline-mono': return 'es-button outline-mono';
            case 'solid': return 'es-button solid';
            default: return '';
        }
    }

    @HostBinding('style.--background-color')
    get backgroundColor()
    {
        switch(this.fill)
        {
            case 'outline':
            case 'outline-mono':
            case 'solid': return `var(--color-${this.color})`;
            default: return null;
        }
    }

    @HostBinding('style.--color')
    get kolor()
    {
        switch(this.fill)
        {
            case 'clear': return `var(--color-${this.color})`;
            case 'solid': return `var(--color-${this.color}-contrast)`;
            default: return null;
        }
    }

    @HostBinding('style.--background-hover-color')
    get backgroundHoverColor()
    {
        switch(this.fill)
        {
            case 'outline':
            case 'outline-mono':
            case 'solid': return `var(--color-${this.color}-hover)`;
            default: return null;
        }
    }
    private get isDisabled(): boolean {
        return this.el.nativeElement.hasAttribute('disabled');
    }
    @HostBinding('class.disabled')
    get hostDisabledClass(): boolean {
        return this.isDisabled;
    }

    @HostBinding('style.--background-disabled-color')
    get backgroundDisabledColor(): string | null {
        if (!this.isDisabled) return null;

        switch (this.fill) {
        case 'outline':
        case 'outline-mono':
        case 'solid': return `var(--color-${this.color}-disabled)`;
        default:
            return null;
        }
    }
    @HostBinding('style.--background-disabled-text-color')
    get textDisabledColor(): string | null {
        if (!this.isDisabled) return null;

        switch (this.fill) {
        case 'outline':
        case 'outline-mono':
        case 'solid': return `var(--color-${this.color}-text-disabled)`;
        default:
            return null;
        }
    }
    @HostBinding('style.--background-active-color')
    get activeColor(): string | null {
        if (!this.isDisabled) return null;

        switch (this.fill) {
        case 'outline': return `var(--color-${this.color}-outline-active)`;
        case 'outline-mono': return `var(--color-${this.color}-outline-active)`;
        case 'solid': return `var(--color-${this.color}-active)`;
        default:
            return null;
        }
    }
}
